export interface ErrorResponse {
  error: {
    errorCode: string;
  };
}

export const isErrorResponse = (e: unknown): e is ErrorResponse => {
  return (e as ErrorResponse).error !== undefined;
};
